$(document).ready(function () {

    if ($('.grid__carousel').length) {
        //slider 1 todo-projectos
        $('.grid__carousel').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            speed: 700,
            //autoplay: true,
            autoplaySpeed: 7000,
            arrows: false,
            rows: 3,
            responsive: [{
                breakpoint: 992,
                settings: {
                    rows: 1,
                    //slidesToShow: 1,
                    dots: true,
                    arrows: false,
                }
            },
                {
                    breakpoint: 768,
                    settings: {
                        rows: 1,
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
        });
    }

    //1 slider
    if ($('.hero__carousel').length) {
        $('.hero__carousel').on('init', function (event, slick) {
            $('.hero__carousel').append('<div class="slider-count bien__number"><p><span id="current">1</span>/<span id="total">' + slick.slideCount + '</span></p></div>');
        });
        $('.hero__carousel').slick({
            infinite: true,
            speed: 700,
            // autoplay: true,
            autoplaySpeed: 7000,
            prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/left.svg"></button>',
            nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/right.svg"></button>',
            responsive: [{
                breakpoint: 931,
                settings: {
                    dots: true,
                    arrows: false
                }
            }]
        });
        $('.hero__carousel').on('afterChange', function (event, slick, currentSlide) {
            // finally let do this after changing slides
            $('.slider-count #current').html(currentSlide + 1);
        });
    }

    //slider 2
    if ($('.years__carousel').length) {
        $('.years__carousel').slick({
            slidesToShow: 2,
            variableWidth: true,
            slidesToScroll: 1,
            infinite: true,
            speed: 700,
            autoplaySpeed: 7000,
            arrows: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    variableWidth: false
                }
            }]
        });
    }

    if ($('.BabyPelones__carousel1').length) {
        //slider 3
        $('.BabyPelones__carousel1').slick({
            rows: 0,
            slidesToShow: 4,
            //autoplay: true,
            slidesToScroll: 1,
            //infinite: true,
            speed: 700,
            autoplaySpeed: 7000,
            arrows: false,
            // prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/left.svg"></button>',
            // nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/right.svg"></button>',
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    arrows: false,
                    vertical: true,
                    verticalSwiping: true
                }
            }]
        });
    }

});